'use strict';
import angular from 'angular';
import $ from 'jquery';
import moment from 'moment';

import cellTemplateHtmlUrl from '../views/cellTemplate.html';

angular.module('nightlystatus.ctrls', [])
    .controller('NightlyStatusController', NightlyStatusController);

NightlyStatusController.$inject = ['$scope', '$ioAlert', '$rootScope', '$timeout', '$sce', '$modal', 'UserService', 'NightlyStatusService', 'ModalService', 'ClusterService'];
function NightlyStatusController ($scope, $ioAlert, $rs , $timeout, $sce, $modal, UserService, NightlyStatusService, ModalService, ClusterService) {
    $scope.tableHide = true;
    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        },function(){});
    }

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        $scope.calendarRefetch($scope.calendarDay);
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    function genCalItems(data) {
        return $.map(data, function(datum) {
            var type = 'important';
            return {
                cssClass: 'custom-entry',
                data: {
                    total: datum.total,
                    date_string: datum.created_at,
                },
                type: type,
                reserved: 'open',
                startsAt: moment(datum.created_at).toDate(),
                endsAt: moment(datum.created_at).toDate(),
                draggable: false,
                resizeable: false,
                editable: false,
                deletable: false
            }
        })
    }

    function showLogsModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, {data: data}));
    }

    function init() {
        $scope.redraw = false;
        ClusterService.initCluster($rs.userRole, 'hidden');
        $scope.events = {};

        //Calendar templateUrl
        $scope.cellTemplate = $sce.getTrustedResourceUrl(cellTemplateHtmlUrl);

        $scope.calendarRefetch = function(calendarDay) {
            $rs.loadingInProgress = true;
            $rs.loadertitle = "Fetching Nightly Status";
            NightlyStatusService.timedTasks(calendarDay).then(function(data){
                $scope.events = genCalItems(data);
                $rs.loadingInProgress = false;
                $scope.tableHide = false;
                $timeout(function(){
                    $scope.redraw = true;
                    $scope.$apply();
                    $scope.redraw = false;
                });
            });
        };

        $scope.timespanClick = function(events) {
            if(events.length > 0) {
                showLogsModal('nightlyStatus', {events: events}).result.then(function(stuff) {
                    //do nothing
                }, function(cancel) {
                    //still do nothing
                });
            }
        };

        //These variables MUST be set as a minimum for the calendar to work
        $scope.calendarView = 'month';
        $scope.calendarDay = new Date();
        $scope.events = [];

        //Disable calendar by default until inventory selections have been made
        $scope.calendarTitle = "Status";
    }
}